import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { api } from "@/lib/api";
import { Reveal } from "./Reveal";
import { PlayerCard } from "../plantel/PlayerCard";
import { ArrowRight, Loader2, Users } from "lucide-react";

export const PlantelTabs = () => {
  const [groups, setGroups] = useState(null);
  const [tab, setTab] = useState(0);

  useEffect(() => {
    api.get("/plantel/home").then(({ data }) => { setGroups(data); }).catch(() => setGroups([]));
  }, []);

  const current = groups && groups.length > 0 ? groups[Math.min(tab, groups.length - 1)] : null;

  return (
    <section id="plantel" className="relative py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-3xl">
          <span className="section-tag">Conocé al plantel</span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-navy" style={{ fontFamily: "Outfit" }}>
            Las caras de la camiseta
          </h2>
          <p className="mt-4 text-lg text-gray-600 leading-relaxed">
            Elegí una categoría y descubrí a sus jugadores. Entrá a cada ficha para conocer su historia.
          </p>
        </Reveal>

        {groups === null ? (
          <div className="mt-12 py-16 flex justify-center text-navy/40"><Loader2 className="h-7 w-7 animate-spin" /></div>
        ) : groups.length === 0 ? (
          <div className="mt-12 py-16 text-center text-gray-400">
            <Users className="h-10 w-10 mx-auto" />
            <p className="mt-3">Todavía no hay jugadores cargados.</p>
          </div>
        ) : (
          <>
            {/* Pill tabs */}
            <div className="mt-9 flex flex-wrap gap-2">
              {groups.map((g, i) => (
                <button
                  key={g.category}
                  data-testid={`plantel-tab-${i}`}
                  onClick={() => setTab(i)}
                  className={`px-4 sm:px-5 py-2.5 rounded-full text-sm font-bold transition-colors ${
                    tab === i ? "bg-navy text-white" : "bg-[#eef1f7] text-navy hover:bg-navy/10"
                  }`}
                >
                  {g.category}
                </button>
              ))}
            </div>

            <AnimatePresence mode="wait">
              <motion.div
                key={tab}
                initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -8 }}
                transition={{ duration: 0.3 }}
                className="mt-8"
              >
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
                  {current.players.map((p, i) => <PlayerCard key={p.id} player={p} i={i} />)}
                </div>
                <div className="mt-8">
                  <Link
                    to={`/plantel/${current.roster_slug}`}
                    data-testid={`plantel-tab-cta-${tab}`}
                    className="group inline-flex items-center gap-2 bg-navy text-white font-semibold px-6 py-3.5 rounded-xl hover:bg-[#16235a] transition-colors"
                  >
                    Ver todo el plantel de {current.category}
                    <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
                  </Link>
                </div>
              </motion.div>
            </AnimatePresence>
          </>
        )}
      </div>
    </section>
  );
};
